export class FabHoldReason {
    id!: string
    indexId!: number
    name!: string
    sortOrder!: number
    active!: boolean
    modifiedDate?: Date | string
    modifiedByUserId?: string
}
